"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = void 0;
const react_1 = require("react");
const aws_amplify_1 = require("aws-amplify");
const useUser = () => {
    const [user, setUser] = react_1.useState();
    react_1.useEffect(() => {
        (async () => {
            const user = await aws_amplify_1.Auth.currentAuthenticatedUser();
            setUser(user);
        })();
    }, []);
    return user;
};
exports.useUser = useUser;
//# sourceMappingURL=index.js.map